import React from 'react'
/**
 * These are not cacheable and therefore not optimized.
 * But they work in cms server side rendering
 **/

const EthosLogoFancyE = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 83 16"
    {...props}
  >
    <title>ethos-logo-E</title>
    <path d="M11.6369 0.200348V3.32171H3.07416V6.44307H10.5316V9.53622H3.07416V12.6852H11.6369V15.7784H0V0.200348H11.6369Z" fill="#056257"/>
  </svg>
)

export default EthosLogoFancyE
